export default __webpack_public_path__ + "static/media/RecipeBoardLogo.d9b62324.png";